import { render, staticRenderFns } from "./LeftSidebar.vue?vue&type=template&id=39ed3f0b&"
import script from "./LeftSidebar.vue?vue&type=script&lang=js&"
export * from "./LeftSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports